import { mapGetters } from 'vuex'
import USER_TYPES from '@/constants/authorization/user-types'
import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

const PermissionMixin = {
  data() {
    return {
      USER_TYPES,
      ADMIN_PERMISSIONS,
    }
  },
  computed: {
    ...mapGetters({
      isSuperAdmin: 'permissions/isSuperAdmin',
      isManager: 'permissions/isManager',
      isOwner: 'permissions/isPrimaryAccount',
      isPrimaryAccount: 'permissions/isPrimaryAccount',
      isPrimaryAccount: 'permissions/isPrimaryAccount',
      isSubUser: 'permissions/isSubUser',
      isBranchAdmin: 'permissions/isBranchAdmin',
      isChef: 'permissions/isChef',
      isSupervisor: 'permissions/isSupervisor',
      isWaiter: 'permissions/isWaiter',
      isKitchenUser: 'permissions/isKitchenUser',
      isUserHasType: 'permissions/isUserHasType',
      hasSubuserPermission: 'permissions/hasSubuserPermission',
      hasAnySubuserPermission: 'permissions/hasAnySubuserPermission',
      hasAllSubuserPermissions: 'permissions/hasAllSubuserPermissions',
      hasSubuserRole: 'permissions/hasSubuserRole',
      subuserPermissions: 'permissions/subuserPermissions',
      subuserRoles: 'permissions/subuserRoles',
    }),
  },
}

export default PermissionMixin
